import {Component, OnInit} from '@angular/core';
import {AcNavAutoService} from './ac-nav-auto.service';

@Component({
    selector: 'ac-nav-auto',
    templateUrl: './ac-nav-auto.component.html',
    styleUrls: ['./ac-nav-auto.component.less']
})
export class AcNavAutoComponent {


    constructor(public acNavAutoService: AcNavAutoService) {
    }

    getChildren(route: any) {
        return route?.routeConfig.children || route?.routeConfig._loadedConfig?.routes[0].children;
    }
}
